import React from "react";
import { Navigate, useLocation } from "react-router";
import { Routes as AppRoutes } from "constants/routes";

export const RecoveryPasswordCompleted = () => {
  const search = useLocation().search;
  return <Navigate to={`${AppRoutes.NewPassword}${search}`} />;
};
